import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  sectionContainer: { gap: theme.spacing(2), width: '100%', margin: theme.spacing(4) },
  sectionHeader: { width: '100%' },
  card: {
    padding: theme.spacing(8),
    width: '100%',
    backgroundColor: theme.colorPalette.beige_25
  },
  textareaField: {
    width: '100%'
  }
});

export default makeStyles(styles);
